import { request } from './apiClient'
export const fetchNotifications = () => request('GET', '/v1/notifications/')
export const fetchUnreadCount = () => request('GET', '/v1/notifications/unread_count/')
export const markNotificationRead = (id) =>
  request('PATCH', `/v1/notifications/${id}/`, { is_read: true })
export const markAllNotificationsRead = () =>
  request('POST', '/v1/notifications/mark_all_read/')
